import {
	MessagingAcceptTransferRequest,
	MessagingRejectTransferRequest,
} from "@/common/models/messagingTransfer";
import { Controller, Endpoint } from "..";
import { Client, mapUrl } from "../client";
import { MessagingOfferNotification } from "@/common/models/messagingNotification";
import { AxiosResponse } from "axios";
import { InitiateTransferRequest } from "@/common/types/transfer";
import { TransferStartResponse } from "@/common/types";
import { TransferDestination } from "@/components/organisms/interactionTransferToIvr/types";
import { AssignInteractionRequest } from "../models/assignInteraction";
import { WebchatVideoCallRequestCreatedResponse } from "../models/webchatCallRequest";

export const acceptWebchatConversation = (
	conversationId: string
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Webchat, conversationId, Endpoint.Accept);

	return Client.instance.post(url);
};

export const acceptWebchatConversationTransfer = (
	data: MessagingAcceptTransferRequest
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Webchat, Endpoint.MessagingTransferAccept);

	return Client.instance.post(url, data);
};

export const rejectWebchatConversation = (
	conversationId: string
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Webchat, conversationId, Endpoint.Reject);

	return Client.instance.post(url);
};

export const rejectWebchatConversationTransfer = (
	data: MessagingRejectTransferRequest
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Webchat, Endpoint.MessagingTransferReject);

	return Client.instance.post(url, data);
};

export const fetchCurrentWebchatInvite =
	(): Promise<MessagingOfferNotification> => {
		return Client.instance.get(Controller.Webchat);
	};

export const closeWebchatConversation = (
	conversationId: string
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Webchat, conversationId, Endpoint.Close);

	return Client.instance.post(url);
};

export const markLastMessageAsSeen = (
	conversationId: string
): Promise<AxiosResponse> => {
	const url = mapUrl(
		Controller.Webchat,
		conversationId,
		Endpoint.MarkLastMessageAsSeen
	);

	return Client.instance.post(url);
};

export const pickUpWebchat = (id: string): Promise<any> => {
	const url = mapUrl(Controller.Webchat, Endpoint.PickUp);

	return Client.instance.post(url, id);
};

export const assignWebchat = (data: AssignInteractionRequest): Promise<any> => {
	const url = mapUrl(Controller.Webchat, Endpoint.Assign);

	return Client.instance.post(url, data);
};

export const getWebchatSummary = (conversationId: string): Promise<string> => {
	return Client.instance.get<string>(
		mapUrl(Controller.Webchat, conversationId, Endpoint.Summary)
	);
};

export const getWebChatTransferDestinations = (): Promise<
	TransferDestination[]
> => {
	const url = mapUrl(
		Controller.Webchat,
		Endpoint.MessagingTransferDestinations
	);

	return Client.instance.get(url);
};

export const transferWebChat = (
	data: InitiateTransferRequest
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.Webchat, Endpoint.MessagingTransfer);

	return Client.instance.post(url, data);
};

export const transferToQueueWebChat = (
	data: InitiateTransferRequest
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.Webchat, Endpoint.MessagingTransferToQueue);

	return Client.instance.post(url, data);
};

export const createWebchatVideoCallRequest = (
	conversationId: string,
	applicationInstanceId: string
): Promise<WebchatVideoCallRequestCreatedResponse> => {
	return Client.instance.post(
		mapUrl(Controller.Webchat, conversationId, Endpoint.VideoCallRequest),
		{ applicationInstanceId }
	);
};

export const cancelWebchatVideoCallRequest = (
	conversationId: string,
	requestId: string
): Promise<AxiosResponse> => {
	return Client.instance.post(
		mapUrl(Controller.Webchat, conversationId, Endpoint.VideoCallCancel),
		{ requestId }
	);
};

export const parkWebChat = (conversationId: string): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Webchat, conversationId, Endpoint.Park)
	);
};

export const unParkWebChat = (conversationId: string): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Webchat, conversationId, Endpoint.UnPark)
	);
};
